import { Record } from 'immutable';

export const QuestionnaireItems = new Record({
  isPending: false,
  error: null,
  data: [],
  starts_from: 0
});